import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropType from "prop-types";
import creditzActions from "../../../redux/creditz/actions";
import RecievedCreditz from "./recieved";
import SentCreditz from "./sentCreditz";
import Header from "./header";
import styles from "./style.module.scss";

const Tabs = ({ setAddNewCreditz, setView, setValues }) => {
  const dispatch = useDispatch();
  const { creditz } = useSelector((state) => ({ creditz: state.creditz }));
  const [selected, setSelected] = useState("Recieved");
  useEffect(() => {
    dispatch({
      type: creditzActions.GET_RECEIVED_CREDITZ,
    });
  }, []);

  const updateNotification = (notifId, status) => {
    dispatch({
      type: creditzActions.UPDATE_NOTIFICATION,
      payload:{notifId, status}
    });
  }
  return (
    <>
      <div className={styles.tabsContainer}>
        <div className={styles.buttonContainer}>
          <button
            onClick={() => setSelected("Recieved")}
            className={selected === "Recieved" && styles.selected}
          >
            Recieved
          </button>
          <button
            onClick={() => setSelected("Sent")}
            className={selected === "Sent" && styles.selected}
          >
            Sent
          </button>
        </div>
        <div className={styles.tabsContent}>
          {selected === "Recieved" && (
            <RecievedCreditz creditz={creditz.creditz} setView={setView} setValues={setValues} updateNotification={updateNotification} />
          )}
          {selected === "Sent" && (
            <SentCreditz setView={setView} setValues={setValues} />
          )}
        </div>
      </div>
    </>
  );
};

Tabs.propTypes = {
  setAddNewCreditz: PropType.func,
  setView: PropType.func,
  setValues: PropType.func,
}

export default Tabs;
